import { useState } from 'react';
import axios from 'axios';

const PRIVACY_PATH = '/confidentialite';

const copy = {
  En: {
    title: 'CAPITAL & CLARITY',
    text: 'One market reading and one concrete wealth implication, twice a month. No noise, no promises.',
    offer: 'Subscribe and receive the guide Digital Assets in a Wealth Structure: 10 questions to settle before allocating.',
    placeholder: 'Your email',
    button: 'Get the guide',
    sending: 'Sending…',
    consentA: 'I agree to receive the Capital & Clarity newsletter and accept the ',
    consentB: 'privacy policy',
    consentC: '.',
    needConsent: 'Please tick the box to continue.',
    invalid: 'Please enter a valid email address.',
    tooMany: 'Too many attempts. Please try again later.',
    error: 'Something went wrong. Please try again.',
    done: 'Thank you. The guide is on its way to your inbox.'
  },
  Fr: {
    title: 'CAPITAL & CLARITY',
    text: 'Une lecture de marché et une implication patrimoniale concrète, deux fois par mois. Sans bruit, sans promesse.',
    offer: 'Inscrivez-vous et recevez le guide Digital Assets in a Wealth Structure : 10 questions à trancher avant d’allouer. La lettre est rédigée en anglais.',
    placeholder: 'Votre email',
    button: 'Recevoir le guide',
    sending: 'Envoi…',
    consentA: 'J’accepte de recevoir la lettre Capital & Clarity et la ',
    consentB: 'politique de confidentialité',
    consentC: '.',
    needConsent: 'Veuillez cocher la case pour continuer.',
    invalid: 'Veuillez saisir une adresse e-mail valide.',
    tooMany: 'Trop de tentatives. Veuillez réessayer plus tard.',
    error: 'Une erreur est survenue. Veuillez réessayer.',
    done: 'Merci. Le guide arrive dans votre boîte mail.'
  }
};

export default function NewsletterSignup({ lang = 'En', sourcePage = 'home', compact = false }) {
  const c = copy[lang] || copy.En;
  const [email, setEmail] = useState('');
  const [consent, setConsent] = useState(false);
  const [website, setWebsite] = useState('');
  const [status, setStatus] = useState('idle');
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    if (status === 'loading') return;
    if (!consent) {
      setError(c.needConsent);
      return;
    }
    setStatus('loading');
    setError('');
    try {
      await axios.post('/api/public/newsletter/subscribe', {
        email,
        consent: true,
        lang: lang === 'Fr' ? 'Fr' : 'En',
        sourcePage,
        website
      });
      setStatus('done');
    } catch (err) {
      setStatus('idle');
      const code = err?.response?.status;
      setError(code === 400 ? c.invalid : code === 429 ? c.tooMany : c.error);
    }
  };

  return (
    <section id="newsletter" className={`${compact ? 'py-14 border-y' : 'py-24 border-t'} bg-[var(--color-surface)] border-[var(--color-line)]`}>
      <div className="max-w-3xl mx-auto px-6 text-center">
        <p className="text-[var(--color-gold)] font-bold text-xs uppercase tracking-[0.3em] mb-6">{c.title}</p>
        <p className="text-2xl md:text-3xl font-light tracking-tight janus-title mb-5">{c.text}</p>
        <p className="janus-text-muted font-light leading-relaxed mb-10">{c.offer}</p>
        {status === 'done' ? (
          <p className="text-[var(--color-gold)] font-medium">{c.done}</p>
        ) : (
          <form onSubmit={submit} className="max-w-xl mx-auto">
            <div className="flex flex-col sm:flex-row gap-3">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={c.placeholder}
                autoComplete="email"
                className="flex-1 border border-[var(--color-line)] bg-white px-5 py-4 text-sm font-light outline-none focus:border-[var(--color-gold)]"
              />
              <input
                type="text"
                name="website"
                value={website}
                onChange={(e) => setWebsite(e.target.value)}
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                className="hidden"
              />
              <button
                type="submit"
                disabled={status === 'loading'}
                className="bg-[var(--color-black)] text-white px-8 py-4 text-[10px] font-bold tracking-[0.2em] uppercase hover:bg-[var(--color-gold)] transition disabled:opacity-60"
              >
                {status === 'loading' ? c.sending : c.button}
              </button>
            </div>
            <label className="flex items-start gap-3 mt-5 text-left text-xs font-light janus-text-muted leading-relaxed cursor-pointer">
              <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-0.5" />
              <span>
                {c.consentA}
                <a href={PRIVACY_PATH} target="_blank" rel="noreferrer" className="underline">{c.consentB}</a>
                {c.consentC}
              </span>
            </label>
            {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
          </form>
        )}
      </div>
    </section>
  );
}
